import jQuery from 'jquery';

export default class Timeline {
  constructor(root) {
    this.container = root;
    this.timelineItems = this.container.querySelectorAll('.timeline__item');
    
    this.timelineItems.forEach((element, idx) => {
      jQuery(element).find('.timeline__header').on('click', (event) => this.handleOpen(event.target));
      if (idx === 0) {
        element.classList.add('active--start');
      }
    });
  }

  handleOpen(target) {
    const item = target.closest('.timeline__item');
    // const activeItems = this.container.querySelectorAll('.active, .active--start');
    const content = jQuery(item).children('.timeline__content');
    if (item.classList.contains('active--start') || item.classList.contains('active')) {
      jQuery(content).slideUp({
      duration: 400,
      easing: 'swing',
      // specialEasing: 'ease-in-out'
    });
      jQuery(item).delay(401).removeClass('active active--start');

    } else {
      // activeItems.forEach(element => {
      //   jQuery(element).find('.timeline__content').slideUp({
      //     duration: 400,
      //     easing: 'swing',
      //     // specialEasing: 'ease-in-out',
      //     start: function() {
      //       jQuery(this).css('display','flex');
      //     }
      //   });
      //     jQuery(element).delay(401).removeClass('active active--start');
      // });
      item.classList.add('active');
      jQuery(content).slideDown({
        duration: 400,
        easing: 'swing',
        // specialEasing: 'ease-in-out',
        start: function() {
          jQuery(this).css('display','flex');
        }
      });
    }
  }
}